import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { actions } from './../../../market';
import { actions as profileActions } from './../../../../../../modules/profile';

const propTypes = {
	intl: PropTypes.func,
	contest_points: PropTypes.number,
	prefferedGift: PropTypes.object,
	handleOrder: PropTypes.func,
	saveUpForGood: PropTypes.func,
	user: PropTypes.object,
	lang: PropTypes.string,
	fetchData: PropTypes.func,
	userData: PropTypes.object,
	lists: PropTypes.object,
	saveInLocalStorage: PropTypes.func
};

class SaveupHint extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showApproveForm: false
		};
	}
	render() {
		const { contest_points, prefferedGift, intl, user, lang } = this.props;
		let present_text = '';
		let isOrderButton = false;
		if (!_isEmpty(prefferedGift) && prefferedGift.price > parseFloat(contest_points)) {
			present_text = `${intl('Для подарка нужно еще')} ${prefferedGift.price - parseFloat(contest_points)}`;
		}
		if (!_isEmpty(prefferedGift) && prefferedGift.price <= parseFloat(contest_points)) {
			present_text = `${intl('Поздравляем! Вы можете получить свой подарок!')}`;
			isOrderButton = true;
		}
		if (!_isEmpty(prefferedGift) && (!!prefferedGift.removed_at || prefferedGift.status === 'hidden')) {
			present_text = `${intl('Ваш подарок отсутствует. Выберите другой')}`;
			isOrderButton = false;
		}

		return (
			<div className="saveup-hint__container">
				{Boolean(present_text.length) && <div className="saveup-hint__text">{present_text}</div>}
				{isOrderButton &&
					<button
						className="order-btn"
						onClick={() => {this.setState(state => ({showApproveForm: !state.showApproveForm}));}}
					>
						{intl('Получить')}
					</button>
				}
				{this.state.showApproveForm && (
					<div>
						<div className="saveup-hint__text">{intl('Вы уверены что хотите заказать подарок')}</div>
						<div className="order-btn__container">
							<button
								className="order-confirm"
								onClick={() => {
									this.setState({showApproveForm: false});
									this.props.handleOrder({good: prefferedGift, user, marketLang: lang})
										.then(this.props.fetchData);
								}}
							>
								{intl('Да')}
							</button>
							<button
								className="order-confirm option-no"
								onClick={() => {this.setState({showApproveForm: false});}}
							>
								{intl('Нет')}
							</button>
						</div>
					</div>
				)}
				<div className="saveup-hint__text">
					{intl('Завтра сгорит')} {Math.round(user.unspent_points * 100) / 100}
				</div>
				<Link className="to_shop" to={'market'}>{intl('Перейти в магазин')} &gt;</Link>
			</div>
		);
	}
}

SaveupHint.propTypes = propTypes;

const mapStateToProps = state => ({
	prefferedGift: _get(state, 'profile.data.prefferedGift', {}),
	user: _get(state, 'app.userData.general', {}),
	lang: _get(state, 'app.userData.general.language', {})
});

export default connect(mapStateToProps,
	dispatch => bindActionCreators({
		...actions,
		fetchData: profileActions.fetchData
	}, dispatch)
)(SaveupHint);


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/sidebar/balances/components/seveupHint.js